import { addStyles } from 'ethcss'
import 'blocks.app/loader/loader.css'
import { colors, grid, IStyles, mediaCSS } from '../../../theme'

const displayRemoteControlStyles: IStyles = {
    wrapper: {
        background: '#272727',
        width: '100%',
        height: '100%',
        '-webkit-user-select': 'none',
        '-khtml-user-select': 'none',
        '-moz-user-select': 'none',
        '-o-user-select': 'none',
        'user-select': 'none',
    },
    inner: {
        position: 'relative',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: '100%',
        padding: '24px 50px 40px 50px',
        color: colors.white,
        textAlign: 'center',

        [mediaCSS.tab]: {
            display: 'block',
            padding: '70px 15px 40px 15px',
            height: '100%',
        },
    },
    leftBlock: {
        position: 'relative',
        height: '100%',
        width: 'calc(100% - 366px)',

        [mediaCSS.tab]: {
            width: '100%',
            height: 'auto',
            marginBottom: 44,
        },
    },
    caption: {
        fontSize: 24,
        marginBottom: 10,
        paddingTop: 30,
        textAlign: 'center',
        color: colors.white,

        [mediaCSS.tab]: {
            display: 'none',
        },
    },
    backButton: {
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        left: 0,
        top: 32,
        fontSize: 16,
        cursor: 'pointer',
        padding: '0 50px',
        color: colors.white,
        [mediaCSS.tab]: {
            padding: 10,
            zIndex: 1000,
            top: 20,
            left: 10,
        },

        span: {
            marginLeft: 10,

            [mediaCSS.tab]: {
                display: 'none',
                top: 26,
            },
        },
    },
    statusWrapper: {
        position: 'absolute',
        bottom: 12,
        left: 0,
        pointerEvents: 'none',

        [mediaCSS.tab]: {
            display: 'none',
        },
    },
    statusInner: {
        padding: 30,
        pointerEvents: 'none',
    },
    status: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 20,
        fontWeight: 900,
        marginBottom: 10,
    },
    downloadMessage: {
        marginLeft: 10,
    },
    progress: {
        marginTop: 10,
        fontSize: 16,
    },
    statusDescription: {
        fontSize: 16,
    },
    preview: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 'calc(100vh - 130px)',
        overflow: 'hidden',

        [mediaCSS.tab]: {
            height: 'auto',
            maxHeight: 'calc(100vh - 130px)',
        },
    },
    previewInner: {
        maxWidth: '100% !important',
        maxHeight: '100% !important',
        background: colors.black,
        borderRadius: 10,
        overflow: 'hidden',
    },
    iframe: {
        display: 'block',
        pointerEvents: 'none',
    },
    player: {
        display: 'block',
        borderRadius: 10,
        backgroundColor: colors.black,
    },
    rightBlock: {
        display: 'flex',
        alignItems: 'center',
        width: 312,
        height: '100%',
        paddingTop: 54,

        [mediaCSS.tab]: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            height: 'auto',
            paddingTop: 0,
            transform: 'translateY(100%)',
            transition: 'transform 0.3s',
        },
    },
    showMobRemote: {
        transform: 'translateY(0)',
    },
    remote: {
        position: 'relative',
        margin: '0 auto',

        [mediaCSS.tab]: {
            opacity: 0.5,
            transition: 'opacity 0.3s',
        },
    },
    remoteButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        width: 60,
        height: 60,
        borderRadius: '50%',
        //border: '1px solid white',
        cursor: 'pointer',
        transition: 'background-color 0.2s',

        '& img': {
            display: 'block',
            pointerEvents: 'none',
        },
    },
    pressedBtn: {
        backgroundColor: colors.blueAccent,
    },
    arrowLeftBtn: {
        left: 46,
        top: 136,

        [mediaCSS.tab]: {
            top: 118,
            left: 51,
        },
    },
    arrowRightBtn: {
        left: 206,
        top: 136,

        [mediaCSS.tab]: {
            top: 118,
            left: 210,
        },
    },
    arrowUpBtn: {
        left: 126,
        top: 56,

        [mediaCSS.tab]: {
            top: 38,
            left: 132,
        },
    },
    arrowDownBtn: {
        left: 126,
        top: 216,

        [mediaCSS.tab]: {
            top: 197,
            left: 132,
        },
    },
    selectBtn: {
        left: 108,
        top: 118,
        width: '96px !important',
        height: '96px !important',

        [mediaCSS.tab]: {
            top: 100,
            left: 113,
        },
    },
    backBtn: {
        left: 46,
        top: 288,

        [mediaCSS.tab]: {
            top: 269,
            left: 50,
        },
    },
    muteBtn: {
        left: 46,
        top: 376,

        [mediaCSS.tab]: {
            top: 358,
            left: 50,
        },
    },
    homeBtn: {
        left: 206,
        top: 288,

        [mediaCSS.tab]: {
            top: 269,
            left: 210,
        },
    },
    minusBtn: {
        left: 126,
        top: 376,

        [mediaCSS.tab]: {
            top: 358,
            left: 130,
        },
    },
    plusBtn: {
        left: 206,
        top: 376,

        [mediaCSS.tab]: {
            top: 358,
            left: 210,
        },
    },
    fileBtn: {
        left: 126,
        top: 287,

        [mediaCSS.tab]: {
            top: 268,
            left: 131,
        },
    },
    showRemoteBtn: {
        position: 'fixed',
        left: '50%',
        bottom: 20,
        transform: 'translateX(-50%)',
    },
    hideRemoteBtn: {
        position: 'fixed',
        left: '50%',
        bottom: 10,
        transform: 'translateX(-50%)',
    },
    active: {
        [mediaCSS.tab]: {
            opacity: 1,
        },
    },
    connectionStatus: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
    connectionStatusInner: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: 18,
    },
    connectionStatusText: {
        marginBottom: 10,
        fontWeight: 700,
    },
    connectionError: {
        color: colors.notificationRed,
    },
    modal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(0,0,0, 0.7)',
        zIndex: 100,
    },
    modalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        borderRadius: 20,
        padding: 30,
        color: colors.blackLight,
        lineHeight: 1.3,
    },
    modalTitle: {
        fontSize: 22,
        marginBottom: 30,
    },
    modalText: {
        textTransform: 'uppercase',
        marginBottom: 20,
        textAlign: 'center',
    },
    modalDesc: {
        marginTop: 8,
        marginBottom: 40,
    },
    modalFilePath: {
        marginBottom: 50,
    },
    modalButtons: {
        display: 'flex',
        justifyContent: 'center',
    },
    modalButton: {
        margin: '0 6px',
    },
    fileModal: {
        width: 560,
        [mediaCSS.tab]: {
            width: 370,
        },
    },
    placeholderModal: {
        width: 384,
    },
    dropzone: {
        ...grid.row,
        ...grid.full,
    },
    or: {
        margin: '14px 0',
    },
    dropArea: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 70,
        width: '100%',
        border: `1px dashed ${colors.grey}`,
        borderRadius: 10,
        position: 'relative',
        overflow: 'hidden',
    },
    dragInfo: {
        position: 'absolute',
        zIndex: 10000,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    fileSelect: {
        marginBottom: 24,
        textAlign: 'left',
    },
    fileSelectLabel: {
        marginBottom: 8,
    },
    uploadButtonWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    fileName: {
        marginLeft: 14,
    },
    controlPanel: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 230,
        position: 'absolute',
        right: 50,
        top: 30,
        padding: '20px 30px',
        borderRadius: 20,
        backgroundColor: '#141414',
        zIndex: 1,

        [mediaCSS.tab]: {
            top: 10,
            right: 10,
        },
    },
    controlBtn: {
        opacity: 0.5,
        transition: 'opacity 0.3s',

        '&:hover': {
            opacity: 1,
        },
    },
    btnEnabled: {
        opacity: '1 !important',
    },
}

addStyles(displayRemoteControlStyles)
export default displayRemoteControlStyles
